import React from "react";
import styles from "../../assets/styles/styles.less";
import MediaQuery from "react-responsive";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import SelectCharityDesktop from "./SelectCharityDesktop";
import SelectCharityMobile from "./SelectCharityMobile";
import { Loading } from "../Controls";

import { fetchCharities, selectCharity } from "../../actions/actions.js";

class SelectCharity extends React.Component {
  componentWillMount() {
    this.props.fetchCharities();
  }

  render() {
    const { props } = this;
    return (
      <div className="select-charity-container">
        <MediaQuery maxDeviceWidth={740}>
          <SelectCharityMobile {...props} />
        </MediaQuery>
        <MediaQuery minDeviceWidth={741}>
          <SelectCharityDesktop {...props} />
        </MediaQuery>
        {this.props.reducer.loading ? <Loading /> : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    reducer: state.appReducer,
    details: state.detailsReducer
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchCharities,
      selectCharity
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(SelectCharity);



// WEBPACK FOOTER //
// ./components/SelectCharity/SelectCharity.js